import { nombrePropio } from "../common"

/*
	Nombres recortados para listas y tarjetas.

	En WAPP la gente viene con dos nombres y dos apellidos, asi que en una tarjeta
	de telefono "Jose Sindulfo Guillen Romero" ocupa dos renglones y empuja todo
	lo demas. Esteban pidio (2026-09-16) que el profesor salga con primer nombre y
	primer apellido, y el alumno con primer nombre y sus dos apellidos: al alumno
	hay que poder identificarlo sin ambiguedad, al profesor del horario no.

	Se recorta solo para mostrar. El dato completo no se toca.
*/

const partes = (valor : string | null | undefined) : string[] =>
	String(valor || "").trim().split(/\s+/).filter(Boolean)

/** Primer nombre y primer apellido: "Jose Guillen". */
export const nombreDeProfesor = (nombres : string | null | undefined, apellidos : string | null | undefined) : string =>
{
	const n = partes(nombres)[0] || ""
	const a = partes(apellidos)[0] || ""

	return nombrePropio([n, a].filter(Boolean).join(" "))
}

/** Primer nombre y los dos apellidos: "Liany Perez Toledo". */
export const nombreDeAlumno = (nombres : string | null | undefined, apellidos : string | null | undefined) : string =>
{
	const n = partes(nombres)[0] || ""
	const a = partes(apellidos).slice(0, 2)

	return nombrePropio([n, ...a].filter(Boolean).join(" "))
}

export default nombreDeAlumno
